import {$controller} from "rapid/index";

import * as packageVariables from "../../../../package.json";

const dependencies = [];

export class NavbarController extends $controller {

	constructor($injector, $scope, $auth, $rootScope) {
		"ngInject";
		super($injector, dependencies);
		$scope.version = packageVariables.version;
		$scope.auth = $auth;
		$rootScope.$on("$stateChangeSuccess", () => $scope.email = $scope.auth.getUser() ? $scope.auth.getUser().email : null);
		$scope.two_factor_enabled = $scope.auth.getUser() ? $scope.auth.getUser().two_factor_enabled : null;

		this.watchStateChanges();

	}

	watchStateChanges() {
		return this.$rootScope.$on("$stateChangeSuccess", () => window.$("#navbar-navigation").not(".collapsed").click());
	}

	isAuthenticated() {
		return this.$auth.isAuthenticated();
	}

	logout() {
		return this.$auth.logout();
	}

	$navbarBrandRedirect(){
		if(!this.isAuthenticated()){
			return this.$state.go("auth.signin");
		}else{
			return this.$state.go("companies");
		}
	}

	$updateUserRedirect(){
		return this.$state.go("users.update", {uri: this.$filter("encodeUri")(this.$auth.getUser().uri)});
	}

	onTwoFactorStateChange() {
		this.$auth.twoFactorAuthenticationState({enable: !this.$auth.getUser().two_factor_enabled})
			.then((resp) => {
				const msg = resp && resp.detail ? resp.detail : `2Factor is ${!this.$auth.getUser().two_factor_enabled}`;
				this.$mdToast.show(
					this.$mdToast.simple()
						.textContent(msg)
						.position("top right")
						.hideDelay(3000)
				);
			});
	}

}



// WEBPACK FOOTER //
// ./sources/components/layout/navbar/navbar.controller.js